/**
 * @generated SignedSource<<63b1bb3c84d77a5f9c014d28fe9f1c4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavProfile_seller$data = {
  readonly sellerProfile: {
    readonly company: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useIsSellerOnline_seller">;
  readonly " $fragmentType": "NavProfile_seller";
};
export type NavProfile_seller$key = {
  readonly " $data"?: NavProfile_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavProfile_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavProfile_seller",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useIsSellerOnline_seller",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PresenceResults",
          "kind": "LinkedField",
          "name": "presence",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "recentOnlineDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerPreferences",
          "kind": "LinkedField",
          "name": "sellerPreferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "showOnlineStatus",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerProfile",
      "kind": "LinkedField",
      "name": "sellerProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "4e0ff32450078c88f5f81e7af3f73119";

export default node;
